import styles from "./rwe-analytics.module.css";
import ServicoDetalheCover from "../../../components/ServicosComponents/ServicoDetalheCover/servico-detalhe-cover";
import rweAnalyticsIgm from "../../../images/_finais/servico_01_compress.webp";
import { NavLink } from "react-router-dom";

const RweAnalytics = () => {
  return (
    <main className={styles.servico_detalhe_main}>
      <ServicoDetalheCover
        title="RWE Analytics"
        alt="Cover da página RWE Analytics."
      />
      <section className={styles.descricao_section}>
        <div className={styles.div_principal}>
          <p className={styles.paragraph}>
            Realizamos consultorias em análises de dados de mundo real{" "}
            <b>(RWD)</b> de múltiplas fontes, produzindo resultados compilados
            em <b>deck de slides e planilhas</b>, além da disponibilização do{" "}
            <b>banco de dados final</b> de análise acompanhado de{" "}
            <b>dicionário de dados</b> e script de análise.{" "}
          </p>
          <img
            className={styles.image}
            src={rweAnalyticsIgm}
            alt="Imagem do serviço."
            loading="lazy"
          />
        </div>
        <div className={styles.text}>
          <p className={styles.text_paragraph}>
            As análises podem ser desenvolvidas com base em dados próprios do
            cliente, adquiridos em fontes externas ou baseadas em dados abertos,
            como:
          </p>
          <ul className={styles.servico_lista}>
            <li className={styles.lista_item}>
              • Sistemas de Informação em Saúde do SUS
              <ul className={styles.servico_sublista}>
                <li className={styles.lista_item}>
                  • Sistema de Informação sobre Nascidos Vivos <b>(SINASC)</b>
                </li>
                <li className={styles.lista_item}>
                  • Sistema de Informação sobre Mortalidade <b>(SIM)</b>
                </li>
                <li className={styles.lista_item}>
                  • Sistema de Informação de Agravos de Notificação{" "}
                  <b>(SINAN)</b>
                </li>
                <li className={styles.lista_item}>
                  • Sistema de Informação da Vigilância Epidemiológica da Gripe
                  <b>(SIVEP-Gripe)</b>
                </li>
                <li className={styles.lista_item}>
                  • Sistema de Informação Hospitalar <b>(SIH)</b>
                </li>
                <li className={styles.lista_item}>
                  • Sistema de Informação Ambulatorial <b>(SIA)</b>
                </li>
              </ul>
            </li>

            <li className={styles.lista_item}>
              • Inquéritos nacionais (Pesquisa Nacional de Saúde{" "}
              <b>[PNS], Vigitel</b>)
            </li>
            <li className={styles.lista_item}>
              • Sistema previdenciário brasileiro (dados do Instituto Nacional
              do Seguro Social – <b>INSS</b>)
            </li>
          </ul>
        </div>
        <div className={styles.text}>
          <p className={styles.text_paragraph}>
            Como outputs dessas análises, produzimos, dentre outros dados, os
            seguintes:
          </p>
          <ul className={styles.servico_lista}>
            <li className={styles.lista_item}>
              • <b>Indicadores</b> epidemiológicos
            </li>
            <li className={styles.lista_item}>
              • <b>Carga da doença</b> (país, regiões e estados)
            </li>
            <li className={styles.lista_item}>
              • Fração de participação de mercado de tratamentos{" "}
              <b>(market shares)</b>
            </li>
            <li className={styles.lista_item}>
              • Análise de sequenciamento de tratamentos na vida real{" "}
              <b>(jornada do paciente)</b>
            </li>
          </ul>
        </div>
        <div className={styles.btns_div}>
          <NavLink to="/produtos/strategic-planning">
            <button className={styles.btn_produto}>
              {"Ver Strategic Planning"}
            </button>
          </NavLink>
          <NavLink to="/produtos/trainings-workshops">
            <button className={styles.btn_produto}>
              {" Ver Trainings & Workshops"}
            </button>
          </NavLink>
        </div>
        <div className={styles.btns_divMobile}>
          <NavLink to="/produtos/strategic-planning">
            <button className={styles.btn_produto}>{"<"}</button>
          </NavLink>
          <NavLink to="/produtos/trainings-workshops">
            <button className={styles.btn_produto}>{">"}</button>
          </NavLink>
        </div>
      </section>
    </main>
  );
};

export default RweAnalytics;
